export const random_profile_pic = [
  {
    id: 1,
    profile_pic: '/assets/love-random-profiles/12.jpg',
  },
  {
    id: 2,
    profile_pic: '/assets/love-random-profiles/22.jpg',
  },
  {
    id: 3,
    profile_pic: '/assets/love-random-profiles/48-w.jpg',
  },
  {
    id: 4,
    profile_pic: '/assets/love-random-profiles/48.jpg',
  },
  {
    id: 5,
    profile_pic: '/assets/love-random-profiles/50.jpg',
  },
  {
    id: 6,
    profile_pic: '/assets/love-random-profiles/51.jpg',
  },
  {
    id: 7,
    profile_pic: '/assets/love-random-profiles/66.jpg',
  },
  {
    id: 8,
    profile_pic: '/assets/love-random-profiles/49.jpg',
  },
];
